import Select from '@/components/DSE/Select';
import MDinput from '@/components/MDinput';

export function getFormDefinition(vue) {
  return {
    domainCode: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 32,
        caption: 'domain.domainCode'
      }
    },
    domainDescription: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        caption: 'domain.domainDescription'
      }
    },
    priceListItemID: {
      type: Select,
      props: {
        caption: 'linkPriceListItem.priceListItem',
        valueField: 'id',
        labelField: 'description',
        options: vue.$store.getters['priceListItem/loadedItems']
      }
    }
  };
}
